module.exports = __webpack_public_path__ + "img/last-fm.c0362ddf.svg";